import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { adminDownloadJobsApiSlice } from '../features/Admin/adminDownloadJobsApiSlice';
import { adminSlice } from '../features/Admin/adminSlice';
import { systemConfigApiSlice } from '../features/Admin/systemConfigApiSlice';
import { eventsApiSlice } from '../features/events/eventsApiSlice';
import { eventShopApiSlice } from '../features/events/eventShopApiSlice';
import { zipDownloadApiSlice } from '../features/events/zipDownloadApiSlice';
import { rootApiSlice } from '../features/root/rootApiSlice';
import { visitorSlice } from '../features/visitor/visitorSlice';
// import counterReducer from '../features/counter/counterSlice';

export const store = configureStore({
  reducer: {
    visitor: visitorSlice.reducer,
    [adminSlice.reducerPath]: adminSlice.reducer,
    [rootApiSlice.reducerPath]: rootApiSlice.reducer,
    [eventShopApiSlice.reducerPath]: eventShopApiSlice.reducer,
    [zipDownloadApiSlice.reducerPath]: zipDownloadApiSlice.reducer,
    [eventsApiSlice.reducerPath]: eventsApiSlice.reducer,
    [systemConfigApiSlice.reducerPath]: systemConfigApiSlice.reducer,
    [adminDownloadJobsApiSlice.reducerPath]: adminDownloadJobsApiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(
      adminSlice.middleware,
      rootApiSlice.middleware,
      eventShopApiSlice.middleware,
      zipDownloadApiSlice.middleware,
      eventsApiSlice.middleware,
      systemConfigApiSlice.middleware,
      adminDownloadJobsApiSlice.middleware
    );
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
